webpackJsonp([189410179417045],{

/***/ 119:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/Tomer-Gabel.0961605f.jpg";

/***/ }),

/***/ 224:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _TomerGabel = __webpack_require__(119);
	
	var _TomerGabel2 = _interopRequireDefault(_TomerGabel);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TomerGabel = function TomerGabel() {
	  return _react2.default.createElement(
	    'section',
	    { id: 'speaker', className: 'parallax-section' },
	    _react2.default.createElement(
	      'div',
	      { className: 'container' },
	      _react2.default.createElement('br', null),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement(
	        'div',
	        { className: 'row' },
	        _react2.default.createElement(
	          'div',
	          { className: 'col-md-12 col-sm-12 wow fadeInUp', 'data-wow-delay': '0.1s' },
	          _react2.default.createElement(
	            'div',
	            { className: 'team-wrapper' },
	            _react2.default.createElement(
	              'h2',
	              null,
	              'Tomer Gabel'
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'row' },
	              _react2.default.createElement(
	                'div',
	                { className: 'col-md-6' },
	                _react2.default.createElement('img', { src: _TomerGabel2.default, className: 'img-responsive', alt: 'Tomer Gabel' }),
	                _react2.default.createElement(
	                  'ul',
	                  { className: 'social-icon' },
	                  _react2.default.createElement(
	                    'li',
	                    null,
	                    _react2.default.createElement('a', { href: 'https://www.linkedin.com/in/tomergabel/', target: '_blank', className: 'fa fa-linkedin wow fadeIn' })
	                  ),
	                  _react2.default.createElement(
	                    'li',
	                    null,
	                    _react2.default.createElement('a', { href: 'https://twitter.com/tomerg', target: '_blank', className: 'fa fa-twitter wow fadeIn' })
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'col-md-5' },
	                _react2.default.createElement(
	                  'p',
	                  null,
	                  'A programming junkie and computer history aficionado, Tomer\'s been around the block a few times before settling in at WeWork. ',
	                  _react2.default.createElement('br', null),
	                  'Over the years he\'s built any number of (predominantly back-end) systems, cofounded two major Israeli user groups (Java.IL and Underscore), organized an annual Scala conference (Scalape\xF1o) and is a recurring speaker at software conferences. ',
	                  _react2.default.createElement('br', null),
	                  'He secretly still hopes to realize his childhood dream of becoming a lion tamer.'
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'row' },
	              _react2.default.createElement(
	                'h4',
	                null,
	                'Talk: Microservices: A retrospective'
	              ),
	              _react2.default.createElement(
	                'p',
	                null,
	                'SOA has been around for decades, and its latest iteration - microservices - for a while now. Just five years ago microservices were hip, dominating the agenda at conferences; now we almost take them for granted. With microservice-focused conference talks losing steam, the time is ripe to consider what we, as an industry, can learn from the microservice disruption; more importantly, we have a golden opportunity to consider what we have yet to learn!',
	                _react2.default.createElement('br', null),
	                _react2.default.createElement('br', null),
	                'In this talk I\'ll analyse the lessons hammered into us as we\'ve adopted microservices, and take a hard look at the challenges I believe we still struggle with as an industry. If you\'re not doing microservices you\'ll leave the room knowing where the pains will come from; if you are, you will leave with ideas and leads on mitigating these pains.'
	              )
	            )
	          )
	        )
	      )
	    )
	  );
	};
	
	exports.default = TomerGabel;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-speakers-tomer-gabel-js-3692220a81a7a61687b1.js